// Date range types shared with the backend `DateRangeType` enum.
export const DateRangeType = {
    ALL_TIME: 'ALL_TIME',
    THIS_MONTH: 'THIS_MONTH',
    LAST_MONTH: 'LAST_MONTH',
    THIS_QUARTER: 'THIS_QUARTER',
    LAST_QUARTER: 'LAST_QUARTER',
    CUSTOM: 'CUSTOM'
}

// Options rendered in the dropdown (order matters).
export const DATE_RANGE_OPTIONS = [
    { type: DateRangeType.ALL_TIME, label: 'All time' },
    { type: DateRangeType.THIS_MONTH, label: 'This month' },
    { type: DateRangeType.LAST_MONTH, label: 'Last month' },
    { type: DateRangeType.THIS_QUARTER, label: 'This quarter' },
    { type: DateRangeType.LAST_QUARTER, label: 'Last quarter' },
    { type: DateRangeType.CUSTOM, label: 'Custom…' }
]

const toISODate = (date) => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
}

// Resolve concrete from/to bounds for a preset range. Returns nulls for ALL_TIME.
export const getDateRangeBounds = (type, now = new Date()) => {
    const year = now.getFullYear()
    const month = now.getMonth()
    const quarter = Math.floor(month / 3)

    switch (type) {
        case DateRangeType.THIS_MONTH:
            return {
                fromDate: toISODate(new Date(year, month, 1)),
                toDate: toISODate(new Date(year, month + 1, 0))
            }
        case DateRangeType.LAST_MONTH:
            return {
                fromDate: toISODate(new Date(year, month - 1, 1)),
                toDate: toISODate(new Date(year, month, 0))
            }
        case DateRangeType.THIS_QUARTER:
            return {
                fromDate: toISODate(new Date(year, quarter * 3, 1)),
                toDate: toISODate(new Date(year, quarter * 3 + 3, 0))
            }
        case DateRangeType.LAST_QUARTER:
            return {
                fromDate: toISODate(new Date(year, quarter * 3 - 3, 1)),
                toDate: toISODate(new Date(year, quarter * 3, 0))
            }
        case DateRangeType.ALL_TIME:
        default:
            return { fromDate: null, toDate: null }
    }
}

export const DEFAULT_DATE_RANGE = {
    type: DateRangeType.ALL_TIME,
    fromDate: null,
    toDate: null
}

const toShortLabel = (isoDate) => {
    const date = new Date(isoDate)
    if (Number.isNaN(date.getTime())) return ''
    const months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ]
    return `${String(date.getDate()).padStart(2, '0')} ${
        months[date.getMonth()]
    }`
}

// Text shown on the dropdown trigger for the current value.
export const getDateRangeLabel = (value) => {
    if (!value) return 'All time'
    if (value.type === DateRangeType.CUSTOM && value.fromDate && value.toDate) {
        return `${toShortLabel(value.fromDate)} - ${toShortLabel(value.toDate)}`
    }
    const option = DATE_RANGE_OPTIONS.find((opt) => opt.type === value.type)
    return option ? option.label.replace('…', '') : 'All time'
}
